import createElementIfNotDefined from '../../shared/create-element-if-not-defined.js';
import $ from '../../shared/dom.js';

export default function Navigation({ swiper, extendParams, on, emit }) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
    },
  });

  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null,
  };

  function getEl(el) {
    let $el;
    if (el) {
      $el = $(el);
      if (
        swiper.params.uniqueNavElements &amp;&amp;
        typeof el === 'string' &amp;&amp;
        $el.length &gt; 1 &amp;&amp;
        swiper.$el.find(el).length === 1
      ) {
        $el = swiper.$el.find(el);
      }
    }
    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;
    if ($el &amp;&amp; $el.length &gt; 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] &amp;&amp; $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
      if (swiper.params.watchOverflow &amp;&amp; swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }
  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const { $nextEl, $prevEl } = swiper.navigation;

    toggleEl($prevEl, swiper.isBeginning &amp;&amp; !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd &amp;&amp; !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning &amp;&amp; !swiper.params.loop &amp;&amp; !swiper.params.rewind) return;
    swiper.slidePrev();
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd &amp;&amp; !swiper.params.loop &amp;&amp; !swiper.params.rewind) return;
    swiper.slideNext();
  }
  function init() {
    const params = swiper.params.navigation;

    swiper.params.navigation = createElementIfNotDefined(
      swiper,
      swiper.originalParams.navigation,
      swiper.params.navigation,
      {
        nextEl: 'swiper-button-next',
        prevEl: 'swiper-button-prev',
      },
    );
    if (!(params.nextEl || params.prevEl)) return;

    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl &amp;&amp; $nextEl.length &gt; 0) {
      $nextEl.on('click', onNextClick);
    }
    if ($prevEl &amp;&amp; $prevEl.length &gt; 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl &amp;&amp; $nextEl[0],
      $prevEl,
      prevEl: $prevEl &amp;&amp; $prevEl[0],
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }
  function destroy() {
    const { $nextEl, $prevEl } = swiper.navigation;
    if ($nextEl &amp;&amp; $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl &amp;&amp; $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () =&gt; {
    init();
    update();
  });
  on('toEdge fromEdge lock unlock', () =&gt; {
    update();
  });
  on('destroy', () =&gt; {
    destroy();
  });
  on('enable disable', () =&gt; {
    const { $nextEl, $prevEl } = swiper.navigation;
    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) =&gt; {
    const { $nextEl, $prevEl } = swiper.navigation;
    const targetEl = e.target;
    if (
      swiper.params.navigation.hideOnClick &amp;&amp;
      !$(targetEl).is($prevEl) &amp;&amp;
      !$(targetEl).is($nextEl)
    ) {
      if (
        swiper.pagination &amp;&amp;
        swiper.params.pagination &amp;&amp;
        swiper.params.pagination.clickable &amp;&amp;
        (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))
      )
        return;
      let isHidden;
      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }
      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  Object.assign(swiper.navigation, {
    update,
    init,
    destroy,
  });
}
